<template>
  <div
    class="search_box mini"
    v-click-outside="outside"
    :class="[isShowResult && isShow && 'result']"
  >
    <input
      type="text"
      v-model="searchText"
      :placeholder="$t('placeholder.searchForAnswers')"
      @focus="onFocus"
    />
    <div
      class="search_result"
      :style="{
        width: `${widthInput}px`,
        opacity: isShowResult && isShow ? 1 : 0,
      }"
    >
      <ul>
        <li
          v-for="(item, index) in listAnswers"
          :key="index"
          v-on:click="doSelect(item)"
        >
          {{ get(item, `${locale}.title`) }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { includes, isEmpty, filter, find, get } from "lodash";
import slug from "@/utils/slug";
import { mapState } from "vuex";
export default {
  data: () => ({
    searchText: "",
    listAnswers: [],
    isShow: false,
    widthInput: 0,
  }),
  computed: {
    ...mapState({
      categories: "categories",
      answers: "answers",
    }),
    isShowResult() {
      return !isEmpty(this.listAnswers);
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    searchText(value) {
      if (isEmpty(value)) {
        this.listAnswers = [];
      } else if (!isEmpty(this.answers)) {
        const input = slug(value);
        // this.listAnswers = filter(this.categories, (item) => {
        //   const isIncludeAnswers = some(item.answers, (answer) =>
        //     includes(slug(answer.description), input)
        //   );
        //   return (
        //     isIncludeAnswers ||
        //     includes(item.slug, input) ||
        //     includes(slug(item.description), input)
        //   );
        // });
        this.listAnswers = filter(
          this.answers,
          (item) =>
            includes(item.slug, input) ||
            includes(slug(get(item, `${this.locale}.description`)), input)
        );
      }
    },
  },
  methods: {
    get,
    outside() {
      this.isShow = false;
    },
    doSelect(item) {
      const cate = find(
        this.categories,
        (cate) => cate.id === item.category_id
      );
      this.$store.dispatch("setAnswerSelected", item);
      this.$router.push({
        name: "Category",
        params: {
          slug: cate.slug,
          locale: this.locale,
        },
      });
    },
    onFocus(e) {
      this.widthInput = e.target.getBoundingClientRect().width;
      this.isShow = true;
    },
  },
};
</script>
<style lang="scss">
.search_box.mini {
  position: relative;
  padding: 0 10px;
  input {
    width: 300px;
    max-width: 400px;
    text-align: center;
    display: block;
    height: 40px;
    line-height: 40px;
    border-radius: 10px;
    border: none;
    outline: none;
    margin: auto;
    margin-top: 10px;
    padding: 0 10px;
    transition: all 0.5s;
  }
  &.result {
    input {
      border-radius: 10px 10px 0 0;
    }
    .search_result {
      border-radius: 0 0 10px 10px;
    }
  }
  .search_result {
    transition: all 0.3s;
    position: absolute;
    background: rgba(255, 255, 255, 0.9);
    z-index: 1;
    width: 100%;
    overflow: auto;
    max-height: 200px;
    border: 1px solid #f0f0f0;
    left: 0;
    right: 0;
    margin: auto;
    ul {
      padding: 0;
      list-style: none;
      margin: 0;
      li {
        cursor: pointer;
        text-align: left;
        font-size: 20px;
        padding: 10px 5px;
        transition: all 0.3s;
        color: #999;
        &:hover {
          background: #fff;
        }
      }
    }
  }
}
</style>
